import React, { useEffect, useState } from "react";
import { Select, DatePicker, Row, Col } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import VoyageDetails from "../../../../components/VoyageDetails";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { useParams } from "react-router-dom";

const { Option } = Select;

const ViewBunkerDelivery = () => {
  const { bunkerdelivery_id } = useParams();
  const [staffDashboard, setStaffDashboard] = useState([]);
  const [form, setForm] = useState({
    bunkerRefNo: "",
    bunkerDate: moment().format("YYYY-MM-DD"),
    bdnRefNo: "",
    sampleOrigin: "",
    marpolSealNo: "",
    lopIssued: "",
    lopCopyTo: [],
    lopCopyOther: "",
    remarks: "",
    chiefEngSignDigital: "",
    dateSampleDestroyed: null,
    chiefEngSign: "",
  });

  useEffect(() => {
    const staffDashboards = localStorage.getItem("staff_dashboard");
    const parsedData = staffDashboards ? JSON.parse(staffDashboards) : null;

    if (parsedData) {
      setStaffDashboard(parsedData);
      VIEW_BUNKER_DETAILS(parsedData);
    }
  }, []);

  const VIEW_BUNKER_DETAILS = async (voyage_data) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", voyage_data?.voyage_details?.[0]?.id);
    FORM_DATA.append("record_id", atob(bunkerdelivery_id));
    FORM_DATA.append("request_type", "view");
    try {
      const response = await post(ApiURL?.view_bunker_delivery_st_bdn, FORM_DATA);
      if (response?.status === true) {
        const data = response?.data;
        setForm({
          bunkerRefNo: data?.bunker_ref_no || "",
          bunkerDate: data?.bunker_date || "",
          bdnRefNo: data?.bdn_ref_no || "",
          sampleOrigin: data?.sample_origin || "",
          marpolSealNo: data?.marpol_seal_no || "",
          lopIssued:
            data?.lop_issued === true
              ? "Yes"
              : data?.lop_issued === false
              ? "No"
              : "",
          lopCopyTo: Array.isArray(data?.lop_copy_to)
            ? data.lop_copy_to
            : data?.lop_copy_to
            ? [data.lop_copy_to]
            : [],
          lopCopyOther: data?.lop_copy_other || "",
          remarks: data?.remarks || "",
          chiefEngSignDigital: data?.chief_eng_sign_digital || "",
          dateSampleDestroyed: data?.date_sample_destroyed
            ? moment(data.date_sample_destroyed)
            : null,
          chiefEngSign: data?.chief_eng_sign || "",
        });
      }
    } catch (error) {
      console.error("Error in VIEW_BUNKER_DETAILS:", error);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staffDashboard?.voyage_details} />

      <div className="white-container">
        <h3>View Bunker Delivery</h3>
        <br />

        {/* Row 1 */}
        <Row gutter={16}>
          <Col span={12}>
            <AppInput disabled label="Bunker Ref. No" value={form.bunkerRefNo} />
          </Col>
          <Col span={12}>
            <AppInput
              disabled
              type="date"
              label="Bunker Date"
              value={form.bunkerDate}
            />
          </Col>
        </Row>

        {/* Row 2 */}
        <Row gutter={16}>
          <Col span={12}>
            <AppInput disabled label="BDN Ref. No" value={form.bdnRefNo} />
          </Col>
          <Col span={12}>
            <label className="form-label">Sample Origin (Supplier/Ship)</label>
            <Select disabled value={form.sampleOrigin} style={{ width: "100%" }}>
              <Option value="Supplier">Supplier</Option>
              <Option value="Ship">Ship</Option>
              <Option value="Both">Supplier & Ship both</Option>
            </Select>
          </Col>
        </Row>

        {/* Row 3 */}
        <Row gutter={16}>
          <Col span={12}>
            <AppInput
              disabled
              label="MARPOL Sample Seal No."
              value={form.marpolSealNo}
            />
          </Col>
          <Col span={12}>
            <label className="form-label">LOP Issued</label>
            <Select disabled value={form.lopIssued} style={{ width: "100%" }}>
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Col>
        </Row>

        {/* Row 4 */}
        <Row gutter={16}>
          <Col span={12}>
            <label className="form-label">LOP Copy To</label>
            <Select disabled value={form.lopCopyTo} style={{ width: "100%" }}>
              <Option value="Supplier">Supplier</Option>
              <Option value="PSC">PSC</Option>
              <Option value="Vessel">Vessel</Option>
              <Option value="Flag">Flag</Option>
              <Option value="Others">Others</Option>
            </Select>
          </Col>
          {form.lopCopyTo.includes("Others") && (
            <Col span={12}>
              <AppInput
                disabled
                label="LOP Copy - Specify Others"
                value={form.lopCopyOther}
              />
            </Col>
          )}
        </Row>

        {/* Row 5 */}
        <Row gutter={16}>
          <Col span={12}>
            <AppInput disabled label="Remarks (if any)" value={form.remarks} />
          </Col>
          <Col span={12}>
            <AppInput
              disabled
              label="Chief Eng. Name & Sign (Digital)"
              value={form.chiefEngSignDigital}
            />
          </Col>
        </Row>

        {/* Row 6 */}
        <Row gutter={16}>
          <Col span={12}>
            <label className="form-label">Date Sample Destroyed (if - 12 months)</label>
            <DatePicker
              disabled
              style={{ width: "100%" }}
              value={form.dateSampleDestroyed}
            />
          </Col>
          <Col span={12}>
            <AppInput
              disabled
              label="Chief Eng. Name & Sign"
              value={form.chiefEngSign}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ViewBunkerDelivery;
